export default __webpack_public_path__ + "assets/b842b66fa2c255845ee0e3897eb223fe.mp4";